import { Link } from "react-router-dom";
import { CarFront } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "გვერდი ვერ მოიძებნა — taxipark.ge", description: "საძიებო გვერდი არ არსებობს. იხილე ტაქსის ავტომობილების კატალოგი.", path: "/404" });
  return (
    <main className="min-h-screen bg-[#0A0B0E] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <p className="text-7xl font-bold text-[#D4AF37]/30">404</p>
        <h1 className="text-2xl sm:text-3xl font-semibold text-white mt-4">გვერდი ვერ მოიძებნა</h1>
        <p className="text-gray-400 mt-3 leading-relaxed">
          სამწუხაროდ, ეს გვერდი არ არსებობს ან გადატანილია. იხილე ჩვენი ავტოპარკი ან დაბრუნდი მთავარ გვერდზე.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Link to="/catalog" data-testid="notfound-catalog-cta" className="btn-gold text-base">
            <CarFront className="w-5 h-5" /> ავტომობილების კატალოგი
          </Link>
          <Link to="/" data-testid="notfound-home-cta" className="btn-ghost text-base">მთავარი გვერდი</Link>
        </div>
      </div>
    </main>
  );
}
